import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, } from "recharts";
import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const VisitorsParcelsWeek = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Create mock data for the past 7 days
    const generateMockData = () => {
      const today = new Date();
      const mock = Array.from({ length: 7 }, (_, i) => {
        const date = new Date(today);
        date.setDate(today.getDate() - (6 - i)); // Go back 6 days to today
        return {
          date: date.toLocaleDateString("en-US", { weekday: "short" }), // e.g., "Mon"
          visitors: Math.floor(Math.random() * 10), // 0–9 random visitors
          parcels: Math.floor(Math.random() * 5), // 0–4 random parcels
        };
      });
      return mock;
    };

    // Simulate a loading delay
    setTimeout(() => {
      setChartData(generateMockData());
      setLoading(false);
    }, 500);
  }, []);

  const handleNavigate = () => {
    navigate('/visitors');
  };

  return (
    <div className="card">
      <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
        <MuiTooltip title="These are the numbers of visitors and parcels in the past week." arrow>
          <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
          </IconButton>
        </MuiTooltip>
        <button className="redirect-btn" onClick={handleNavigate}>
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
      </div>

      <h2 className="card-title"><i className="fa fa-building-user" />Visitors & Parcels (Last 7 Days)</h2>

      <div className="chart-container">
        {loading ? (
          <p>Loading...</p>
        ) : chartData.length === 0 || chartData.every(item =>
          (!item.visitors || item.visitors === 0) &&
          (!item.parcels || item.parcels === 0)
        ) ? (
          <p className="text-gray-600 text-center py-10">
            There have been no visitors or parcels within the last 7 days.
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 0 }}            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis tick={false} width={20} />
              <Tooltip />
              <Legend formatter={(value) => {
                if (value === "visitors") return "Visitors";
                if (value === "parcels") return "Parcels";
                return value;
              }} />
              <Line type="monotone" dataKey="visitors" stroke="#445485" />
              <Line type="monotone" dataKey="parcels" stroke="#C86B2C" />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div >
  );
};

export default VisitorsParcelsWeek;